import { Component, OnInit } from '@angular/core';
import { UtilService } from 'src/app/services/util.service';
import { DBService } from 'src/app/services/db.service';
import { ModalController } from '@ionic/angular';
import { Category, Item } from 'src/app/models/menu.model';
import { Input } from '@angular/core';
import { Bonuskarte } from 'src/app/models/bonuskarte.model';

@Component({
  selector: 'app-bonuskarte-detail',
  templateUrl: './bonuskarte-detail.component.html',
  styleUrls: ['./bonuskarte-detail.component.scss'],
})
export class BonuskarteDetailComponent implements OnInit {
  @Input() bonuskarte: Bonuskarte;

  public selectedUI: string = 'normal' //can be 'normal', 'items2Collect','itemsAsReward'

  public startDate: string
  public endDate: string
  selectColorExpanded: boolean;
  titleText: string = 'Bearbeite deine Bonuskarte';

  constructor(public util: UtilService, public db: DBService, private modalCtrl: ModalController) {
    this.util.isModalOpen = true
  }

  setUI(ui: string) {
    this.selectedUI = ui
  }

  ngOnInit() {
    if (!this.bonuskarte) {
      this.bonuskarte = new Bonuskarte(this.db.currentRestaurantKey)
      this.bonuskarte.color = "servicegreen"
      this.titleText = 'Erstelle eine Bonuskarte';
    }

    let date1 = new Date(this.bonuskarte.startDate)
    this.startDate = (date1.getMonth() + 1) + "." + date1.getDate() + "." + date1.getFullYear()
    let date2 = new Date(this.bonuskarte.endDate)
    this.endDate = (date2.getMonth() + 1) + "." + date2.getDate() + "." + date2.getFullYear()
  }

  selectCat(cat: Category) {
    if (this.selectedUI === 'items2Collect') {
      this.bonuskarte.collectCategroies = true;
      this.bonuskarte.id2Collect = cat.id;
    } else {
      this.bonuskarte.bonusAsCategroy = true;
      this.bonuskarte.idAsBonus = cat.id;
    }
    this.setUI('normal')
  }

  selectItem(item: Item) {
    if (this.selectedUI === 'items2Collect') {
      this.bonuskarte.collectCategroies = false;
      this.bonuskarte.id2Collect = item.id;
    } else {
      this.bonuskarte.bonusAsCategroy = false;
      this.bonuskarte.idAsBonus = item.id;
    }
    this.setUI('normal')
  }

  getItem2CollectText(): string {
    if (!this.bonuskarte.id2Collect) return 'nicht gewählt'
    let article: any = this.db.findArticleByID(this.bonuskarte.id2Collect)

    if (article) {
      return (this.bonuskarte.collectCategroies ? "Kategorie: " : "Artikel: ") + article.name
    }
    return "nicht gefunden"
  }

  getItemAsRewardText(): string {
    if (!this.bonuskarte.idAsBonus) return 'nicht gewählt'
    let article: any = this.db.findArticleByID(this.bonuskarte.idAsBonus)

    if (article) {
      return (this.bonuskarte.bonusAsCategroy ? "Kategorie: " : "Artikel: ") + article.name
    }
    return "nicht gefunden"
  }

  selectColor(karte: Bonuskarte, color: string) {
    karte.color = color
    this.selectColorExpanded = false;
  }

  toggleColors() {
    this.selectColorExpanded = true;
  }

  back() {
    this.modalCtrl.dismiss()
  }

  save() {
    if (this.bonuskarte.requiredAmount < 0 ||
      !this.bonuskarte.id2Collect ||
      !this.bonuskarte.idAsBonus ||
      !this.bonuskarte.title ||
      this.bonuskarte.title.trim().length == 0) {
      this.util.presentToast("Bitte fülle alle Felder aus.", 3000, 'toast-warning')
      return
    }

    this.bonuskarte.startDate = new Date(this.startDate).getTime()
    this.bonuskarte.endDate = new Date(this.endDate).getTime()

    this.util.isModalOpen = false
    this.modalCtrl.dismiss(this.bonuskarte)
  }


}






















